import {
  ActivityPopupMeta,
  ActivityPopupRendererProps,
  ActivityType,
} from "./types";
import { CustomerActivityPopupRenderer } from "./customer-activity";
import Container, { EmptyContainer } from "../meta-container";
import { FactorActivityPopupRenderer } from "./factor-activity";
import { ChequeActivityPopupRenderer } from "./cheque-activity";
import { CashActivityPopupRenderer } from "./cash-activity";

const ActivityPopupRenderer = <T extends {}>({
  activity,
  back,
}: ActivityPopupRendererProps<T>) => {
  return (
    <Container<ActivityType, ActivityPopupMeta<T>>
      data={{ data: activity.data, back }}
      type={activity.type}
      match={{
        [ActivityType.None]: EmptyContainer,
        [ActivityType.Customer]: CustomerActivityPopupRenderer,
        [ActivityType.Cheque]: ChequeActivityPopupRenderer,
        [ActivityType.Factor]: FactorActivityPopupRenderer,
        [ActivityType.Cash]: CashActivityPopupRenderer,
      }}
    />
  );
};

export default ActivityPopupRenderer;
